import { inject, ComponentAttached } from "aurelia-framework";
import { DropzoneOptions } from "dropzone";
import { HttpClientService } from "../../services/http-client-service";
import { AuthService } from "../../services/auth/auth-service";
import { AuthConfig } from "../../services/auth/auth-config";

@inject(AuthService, AuthConfig)
export class Import implements ComponentAttached {
  uploadOptions: DropzoneOptions;

  constructor(authService: AuthService, authConfig: AuthConfig) {
    let authHeaders = {};
    authHeaders[authConfig.authHeader!] = authService.getTokenAuthHeaderValue();

    this.uploadOptions = {
      url: HttpClientService.serviceBaseUrl + "/admin/upload",
      headers: authHeaders,
    };
  }

  attached() {}
}
